<template>
  <div>
    <h5
      v-if="(limit < 10)"
      class="sub-heading mb-5"
    >
        {{ $t("home.heresASelectionOfOurPopularProducts") }}
    </h5>

    <a
      v-for="category in rowsCategories"
      :key="category.id"
      href="#"
      class="badge badge-pill badge-light text-dark text-decoration-none mt-4"
      :class="{
          selected: (category.id === selectedCategory.id),
      }"
      @click.stop.prevent="selectCategory(category)"
    >
      {{ $t(`categories.${category.slug}`) }}
    </a>

    <div class="row mt-5">

      <series-item
        v-for="series in rowsSeries"
        :key="series.id"
        :series="series"
      />

      <div class="col-6 col-lg-3 mb-4 mb-lg-0">
        <div class="info">
          <h3 class="mb-4">
            {{ $t("home.lookingForMore") }}
          </h3>

          <p>
            <router-link
              to="/samples"
              class="arrow-link text-primary"
              title="View sample"
            >
              {{ $t("home.downloadOurSampleMaterialForAPreview") }}
            </router-link>
          </p>

          <p>
            <router-link
              to="/contact"
              class="arrow-link text-primary"
              title="Contact us"
            >
                {{ $t("home.wereHappyToHelpContactUsWithAnyQuestionsYouHave") }}
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SeriesItem from "./SeriesItem.vue";

export default {
  name: "SeriesList",

  components: {
    SeriesItem,
  },

  props: {
    limit: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      rowsCategories: [],
      rowsSeries: [],
      selectedCategory: {},
    };
  },

  watch: {
    selectedCategory() {
      axios({
        method: "get",
        url: `/api/categories/${this.selectedCategory.id}/series`,
        params: {
          limit: this.limit || 3,
        },
      })
        .then((response) => {
          this.rowsSeries = response.data;
        });
    },
  },

  mounted() {
    this.getCategories();
  },

  methods: {
    getCategories() {
      axios({
        method: "get",
        url: "/api/categories",
      })
        .then((response) => {
          this.rowsCategories = response.data;
          this.selectedCategory = this.rowsCategories[0];
        });
    },

    selectCategory(category) {
      this.selectedCategory = category;
    },
  },
};
</script>
